module.exports = __webpack_public_path__ + "static/img/HTM_H5.55f65dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HTM_H5.png
// module id = TmFg
// module chunks = 34